<ion-item [lines]="lines" class="person-summary-item">
  <ion-avatar slot="start" class="person-summary-item__avatar">
    <div class="thumbnail-placeholder"></div>
  </ion-avatar>
  <ion-label>
    <h2 class="person-summary-item__name">
      {{ primaryLabel }}
      @if (isCurrentUser) {
        <ion-badge color="tertiary" size="small">You</ion-badge>
      }
    </h2>
    @if (secondaryLabel) {
      <p class="person-summary-item__secondary">{{ secondaryLabel }}</p>
    }
  </ion-label>
</ion-item>
